module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/it-91112a5667cf3e36ab3ad4effe740298.png";